<template>
  <div class="w-100p h-x16 b-b1">
    <shoutouts-rewards-badge-listing-img
      v-if="listing.badge"
      :badge="listing.badge"
    />
    <img
      v-else-if="listing.image"
      :src="listing.image.url"
      class="w-100p h-100p br-t10"
      :style="{ 'object-fit': 'cover' }"
    >
    <img
      v-else-if="listing.image_url"
      :src="listing.image_url"
      class="w-100p h-100p br-t10"
      :style="{ 'object-fit': 'cover' }"
    >
    <cdn-svg
      v-else
      path="rewards_listing_presets/default"
      class="w-100p h-100p br-t10"
      :style="{ 'object-fit': 'cover' }"
    />
  </div>
</template>

<script setup>
 const props = defineProps({
   listing: {
     type: Object,
     required: true,
   },
 });
</script>
